const ComponentDefaultConfig = {
    duration: 600,
    events: {},
    attributes: {},
};

export { ComponentDefaultConfig };
//# sourceMappingURL=config.js.map
